export const CHANGE_CURRENT_PAGE = 'ZipwhipSettings/CHANGE_CURRENT_PAGE'
export const CREATE_ZIPWHIP_SETTING = 'ZipwhipSettings/CREATE_ZIPWHIP_SETTING'
export const FETCH_ZIPWHIP_SETTINGS_LIST = 'ZipwhipSettings/FETCH_ZIPWHIP_SETTINGS_LIST'
export const FETCH_ZIPWHIP_SETTINGS_FOR_OPTIONS = 'ZipwhipSettings/FETCH_ZIPWHIP_SETTINGS_FOR_OPTIONS'
export const REMOVE_ZIPWHIP_SETTING = 'ZipwhipSettings/REMOVE_ZIPWHIP_SETTING'
export const UPDATE_ZIPWHIP_SETTING = 'ZipwhipSettings/UPDATE_ZIPWHIP_SETTING'
